import * as React from 'react';

import {colors} from '../../../colors/colors';

import styles from './item-with-icon.module.css';

type Props = {
    text: string;
    tooltipText?: string;
    icon: React.ComponentType<any> | null | undefined;
};

export function ItemWithIcon(props: Props) {
    const Icon = props.icon;

    return (
        <div data-tip={props.tooltipText} className={styles['item-with-icon']}>
            <div className='truncate'>
                {Icon ? (
                    <Icon
                        style={{marginRight: 4, display: 'inline'}}
                        size={11}
                        fill={colors.grey}
                    />
                ) : null}
                {props.text}
            </div>
        </div>
    );
}
